// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__jv4CY","buttonCancel":"button_buttonCancel__24PF6","buttonOk":"button_buttonOk__1cAkG"};